var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_682_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6559 18.3338L36.6559 18.3338L36.6609 18.339C36.8315 18.511 37.0549 18.5966 37.2788 18.5966C37.5021 18.5966 37.7258 18.5113 37.8976 18.3409C38.2409 18.0003 38.241 17.4423 37.8996 17.0982C37.5586 16.7546 37.0037 16.7523 36.66 17.0932L36.6559 18.3338ZM36.6559 18.3338L36.6551 18.3329M36.6559 18.3338L36.6551 18.3329M36.6551 18.3329C36.3141 17.9892 36.3163 17.4342 36.66 17.0932L36.6551 18.3329Z",
    fill: "#B44D2D",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4639 28.3825H46.7054L46.5346 28.2118L39.3343 21.0115C38.992 20.6691 38.992 20.1141 39.3343 19.7718C39.6767 19.4296 40.2317 19.4296 40.574 19.7718L49.6441 28.8419C49.8085 29.0063 49.9009 29.2294 49.901 29.4618C49.901 29.6943 49.8086 29.9172 49.6442 30.0816L34.0757 45.6502C33.9114 45.8145 33.6884 45.9069 33.4559 45.9069C33.2235 45.9069 33.0005 45.8145 32.8361 45.6502L9.34306 22.1572C9.34306 22.1572 9.34305 22.1572 9.34305 22.1572C9.00075 21.8148 9.00076 21.2598 9.34305 20.9175L24.9114 5.34884C25.2537 5.00664 25.8087 5.00664 26.151 5.34884C26.151 5.34884 26.151 5.34884 26.1511 5.34884L34.9723 14.17C35.3146 14.5124 35.3146 15.0675 34.9723 15.4098C34.6299 15.752 34.0749 15.7519 33.7326 15.4098L26.7811 8.45839L26.6104 8.28768V8.5291V25.6994C26.6104 27.179 27.8139 28.3825 29.2935 28.3825H46.4639ZM24.8575 8.12373V7.88231L24.6868 8.05302L12.2497 20.4901L12.079 20.6608H12.3204H24.7575H24.8575V20.5608V8.12373ZM32.4087 42.7434L32.5794 42.9141V42.6727V30.2356V30.1356H32.4794H29.2937C26.8477 30.1356 24.8575 28.1455 24.8575 25.6994V22.5139V22.4139H24.7575H12.3204H12.079L12.2497 22.5846L32.4087 42.7434ZM34.3324 42.6728V42.9142L34.5031 42.7435L46.9401 30.3064L47.1108 30.1356H46.8694H34.4324H34.3324V30.2356V42.6728Z",
    fill: "#B44D2D",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.976562 25.4047H6.70225C7.18637 25.4047 7.57881 25.7972 7.57881 26.2812C7.57881 26.7654 7.18637 27.1578 6.70225 27.1578H0.976562C0.492442 27.1578 0.1 26.7653 0.1 26.2812C0.1 25.7972 0.492442 25.4047 0.976562 25.4047Z",
    fill: "#B44D2D",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59961 25.4047H9.61426C10.0984 25.4047 10.4908 25.7972 10.4908 26.2812C10.4908 26.7653 10.0984 27.1578 9.61426 27.1578H9.59961C9.11549 27.1578 8.72305 26.7653 8.72305 26.2812C8.72305 25.7972 9.11549 25.4047 9.59961 25.4047Z",
    fill: "#B44D2D",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.978516 15.151H4.10381C4.58793 15.151 4.98037 15.5436 4.98037 16.0276C4.98037 16.5116 4.58793 16.9042 4.10381 16.9042H0.978516C0.494395 16.9042 0.101953 16.5116 0.101953 16.0276C0.101953 15.5436 0.494395 15.151 0.978516 15.151Z",
    fill: "#B44D2D",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29297 15.151H10.9871C11.4712 15.151 11.8637 15.5436 11.8637 16.0276C11.8637 16.5116 11.4712 16.9042 10.9871 16.9042H7.29297C6.80885 16.9042 6.41641 16.5116 6.41641 16.0276C6.41641 15.5436 6.80885 15.151 7.29297 15.151Z",
    fill: "#B44D2D",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64453 30.7755H13.1132C13.5972 30.7755 13.9897 31.1681 13.9897 31.6521C13.9897 32.1361 13.5973 32.5287 13.1132 32.5287H7.64453C7.16041 32.5287 6.76797 32.1361 6.76797 31.6521C6.76797 31.1681 7.16041 30.7755 7.64453 30.7755Z",
    fill: "#B44D2D",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61328 37.0258H17.3827C17.8668 37.0258 18.2593 37.4183 18.2593 37.9023C18.2593 38.3864 17.8668 38.7789 17.3827 38.7789H3.61328C3.12916 38.7789 2.73672 38.3864 2.73672 37.9023C2.73672 37.4183 3.12916 37.0258 3.61328 37.0258Z",
    fill: "#B44D2D",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_682_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9acbfaada2ec5006af48040eaabb0deb.svg";
export { ForwardRef as ReactComponent };